
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    level: 'Level',
    toNextLevel: 'To Next Level',
    creditsAbbrevK: 'K',
    creditsAbbrevM: 'M',
    deposit: 'Deposit {{amount}} coins',
    historyTitle: 'XP History',
    howItWorksTitle: 'How It Works',
    howItWorksFeature1: '{{maxLevel}} levels to unlock',
    howItWorksFeature2: 'Each level requires more XP',
    howItWorksFeature3: 'Complete tasks and stay active to earn XP',
    howItWorksFeature4: 'Get exclusive rewards and take part in activities',
    keyLevels: 'Key Levels',
    xpSourcesTitle: 'How to Earn XP',
    tabActivity: 'Activity',
    tabGameplay: 'Gameplay',
    tabSocial: 'Social',
    rewardsDailyLogin: 'Daily Login',
    rewardsWeeklyStreak: '7-Day Streak',
    rewardsContract: 'Contract Creation',
    rewardsUpgradeSuccess: 'Successful Upgrade',
    rewardsUpgradeFail: 'Failed Upgrade',
    rewardsDrawParticipation: 'Draw Participation',
    rewardsDrawWin: 'Reward from activity',
    rewardsReferralInvite: 'Friend Invitation',
    rewardsReferralDeposit: 'Referral Deposit',
    rewardsCaseBattleWin: 'Case Battle Win',
    rewardsCaseBattleLose: 'Case Battle Loss',
    rewardsRouletteWin: 'Russian Roulette Win',
    rewardsRouletteLose: 'Russian Roulette Loss',
    caseGroupsCheap: 'Cheap Cases',
    caseGroupsMedium: 'Medium Cases',
    caseGroupsExpensive: 'Expensive Cases',
    faqTitle: 'FAQ',
    faqQ1: 'What gives the most XP?',
    faqA1: 'Most XP comes from: opening expensive cases, deposits, draw wins, and inviting active referrals.',
    faqQ2: 'Can I lose my level?',
    faqA2: 'No, your level never drops. XP may be deducted for inactivity, but your achieved level stays with you.',
    faqQ3: 'How to level up faster?',
    faqA3: 'Combine: daily logins, case opening, deposits, inviting friends, and draw participation.',
    faqQ4: 'What does level affect?',
    faqA4: 'Levels give various bonuses: one-time rewards for reaching new levels, permanent privileges, and access to exclusive activities.',
  },
  ru: {
    level: 'Уровень',
    toNextLevel: 'До следующего уровня',
    creditsAbbrevK: 'К',
    creditsAbbrevM: 'М',
    deposit: 'Пополнение {{amount}} монет',
    historyTitle: 'История начислений',
    howItWorksTitle: 'Как работает система',
    howItWorksFeature1: '{{maxLevel}} уровней для прокачки',
    howItWorksFeature2: 'Каждый следующий уровень требует больше XP',
    howItWorksFeature3: 'Выполняй задания и проявляй активность для получения XP',
    howItWorksFeature4: 'Получай эксклюзивные награды за достижения и участвуй в активностях',
    keyLevels: 'Ключевые уровни',
    xpSourcesTitle: 'За что начисляется XP',
    tabActivity: 'Активность',
    tabGameplay: 'Игры',
    tabSocial: 'Друзья',
    rewardsDailyLogin: 'Ежедневный вход',
    rewardsWeeklyStreak: 'Серия входов 7 дней',
    rewardsContract: 'Создание контракта',
    rewardsUpgradeSuccess: 'Успешный апгрейд',
    rewardsUpgradeFail: 'Неудачный апгрейд',
    rewardsDrawParticipation: 'Участие в розыгрыше',
    rewardsDrawWin: 'Награда за активность',
    rewardsReferralInvite: 'Приглашение друга',
    rewardsReferralDeposit: 'Депозит реферала',
    rewardsCaseBattleWin: 'Победа в Case Battles',
    rewardsCaseBattleLose: 'Проигрыш в Case Battles',
    rewardsRouletteWin: 'Победа в русской рулетке',
    rewardsRouletteLose: 'Проигрыш в русской рулетке',
    caseGroupsCheap: 'Дешевые кейсы',
    caseGroupsMedium: 'Средние кейсы',
    caseGroupsExpensive: 'Дорогие кейсы',
    faqTitle: 'Частые вопросы',
    faqQ1: 'Что даёт больше всего XP?',
    faqA1: 'Больше всего XP приносят: открытие дорогих кейсов, пополнения, победы в розыгрышах и приглашение активных рефералов.',
    faqQ2: 'Могу ли я потерять уровень?',
    faqA2: 'Нет, твой уровень никогда не понижается. XP может списываться за неактивность, но достигнутый уровень остается с тобой.',
    faqQ3: 'Как быстрее повысить уровень?',
    faqA3: 'Комбинируй: ежедневный вход, открытие кейсов, пополнения, приглашение друзей и участие в розыгрышах.',
    faqQ4: 'На что влияет уровень?',
    faqA4: 'Уровни дают различные бонусы: разовые награды за достижение новых уровней, постоянные привилегии и доступ к эксклюзивным активностям.',
  },
  uz: {
    level: 'Daraja',
    toNextLevel: 'Keyingi darajagacha',
    creditsAbbrevK: 'K',
    creditsAbbrevM: 'M',
    deposit: '{{amount}} tanga depozit',
    historyTitle: 'XP tarixi',
    howItWorksTitle: 'Qanday ishlaydi',
    howItWorksFeature1: '{{maxLevel}} darajani ochish mumkin',
    howItWorksFeature2: 'Har bir keyingi daraja koʻproq XP talab qiladi',
    howItWorksFeature3: 'Vazifalarni bajaring va XP olish uchun faol boʻling',
    howItWorksFeature4: 'Eksklyuziv mukofotlar oling va faolliklarda qatnashing',
    keyLevels: 'Asosiy darajalar',
    xpSourcesTitle: 'XP qanday olish mumkin',
    tabActivity: 'Faoliyat',
    tabGameplay: 'Oʻyin',
    tabSocial: 'Ijtimoiy',
    rewardsDailyLogin: 'Kunlik kirish',
    rewardsWeeklyStreak: '7 kunlik ketma-ketlik',
    rewardsContract: 'Kontrakt yaratish',
    rewardsUpgradeSuccess: 'Muvaffaqiyatli apgreyd',
    rewardsUpgradeFail: 'Muvaffaqiyatsiz apgreyd',
    rewardsDrawParticipation: 'Qurada qatnashish',
    rewardsDrawWin: 'Faollikda mukofot olish',
    rewardsReferralInvite: 'Doʻstni taklif qilish',
    rewardsReferralDeposit: 'Referal depoziti',
    rewardsCaseBattleWin: 'Keys jangida gʻalaba',
    rewardsCaseBattleLose: 'Keys jangida magʻlubiyat',
    rewardsRouletteWin: 'Rus ruletida gʻalaba',
    rewardsRouletteLose: 'Rus ruletida magʻlubiyat',
    caseGroupsCheap: 'Arzon keyslar',
    caseGroupsMedium: 'Oʻrtacha keyslar',
    caseGroupsExpensive: 'Qimmat keyslar',
    faqTitle: 'Koʻp soʻraladigan savollar',
    faqQ1: 'Eng koʻp XP nima beradi?',
    faqA1: 'Eng koʻp XP: qimmat keyslar ochish, depozitlar, qura gʻalabalari va faol referallarni taklif qilishdan keladi.',
    faqQ2: 'Darajamni yoʻqotishim mumkinmi?',
    faqA2: 'Yoʻq, darajangiz hech qachon tushmaydi. Faolsizlik uchun XP ayirilishi mumkin, lekin erishilgan daraja siz bilan qoladi.',
    faqQ3: 'Qanday tezroq daraja oshirish mumkin?',
    faqA3: 'Birlashtiring: kunlik kirish, keyslar ochish, depozitlar, doʻstlarni taklif qilish va quralarda qatnashish.',
    faqQ4: 'Daraja nimaga taʼsir qiladi?',
    faqA4: 'Darajalar turli bonuslar beradi: yangi darajaga erishganda bir martalik mukofotlar, doimiy imtiyozlar va eksklyuziv faolliklarda qatnashish.',
  },
  fa: {
    level: 'سطح',
    toNextLevel: 'تا سطح بعدی',
    creditsAbbrevK: 'هزار',
    creditsAbbrevM: 'میلیون',
    deposit: '{{amount}} سکه شارژ کن',
    historyTitle: 'تاریخچه XP',
    howItWorksTitle: 'چطور کار می‌کند',
    howItWorksFeature1: '{{maxLevel}} سطح برای باز کردن',
    howItWorksFeature2: 'هر سطح XP بیشتری می‌خواهد',
    howItWorksFeature3: 'کارها را انجام بده و فعال بمان تا XP بگیری',
    howItWorksFeature4: 'جایزه‌های ویژه بگیر و در رویدادها شرکت کن',
    keyLevels: 'سطح‌های کلیدی',
    xpSourcesTitle: 'چطور XP بگیریم',
    tabActivity: 'فعالیت',
    tabGameplay: 'بازی',
    tabSocial: 'اجتماعی',
    rewardsDailyLogin: 'ورود روزانه',
    rewardsWeeklyStreak: 'زنجیره 7 روزه',
    rewardsContract: 'بستن قرارداد',
    rewardsUpgradeSuccess: 'ارتقای موفق',
    rewardsUpgradeFail: 'ارتقای ناموفق',
    rewardsDrawParticipation: 'شرکت در قرعه‌کشی',
    rewardsDrawWin: 'جایزه از فعالیت',
    rewardsReferralInvite: 'دعوت دوست',
    rewardsReferralDeposit: 'شارژ دعوت‌شده',
    rewardsCaseBattleWin: 'برد در نبرد کیس',
    rewardsCaseBattleLose: 'باخت در نبرد کیس',
    rewardsRouletteWin: 'برد در رولت روسی',
    rewardsRouletteLose: 'باخت در رولت روسی',
    caseGroupsCheap: 'کیس‌های ارزان',
    caseGroupsMedium: 'کیس‌های متوسط',
    caseGroupsExpensive: 'کیس‌های گران',
    faqTitle: 'سؤالات پرتکرار',
    faqQ1: 'بیشترین XP از کجا می‌آید؟',
    faqA1: 'بیشترین XP از این‌ها می‌آید: باز کردن کیس‌های گران، شارژ، برد در قرعه‌کشی و دعوت دوستان فعال.',
    faqQ2: 'ممکن است سطحم پایین بیاید؟',
    faqA2: 'نه، سطحت هیچ‌وقت پایین نمی‌آید. برای بی‌فعالیتی ممکن است XP کم شود، اما سطحی که گرفته‌ای مال خودت می‌ماند.',
    faqQ3: 'چطور سریع‌تر سطح بگیرم؟',
    faqA3: 'ترکیب کن: ورود روزانه، باز کردن کیس، شارژ، دعوت دوستان و شرکت در قرعه‌کشی.',
    faqQ4: 'سطح روی چه چیزی اثر دارد؟',
    faqA4: 'سطح‌ها بونوس‌های مختلف می‌دهند: جایزه یک‌باره برای رسیدن به سطح تازه، امتیازهای دائمی و دسترسی به رویدادهای ویژه.',
  },
  pt: {
    level: 'Nível',
    toNextLevel: 'Para o próximo nível',
    creditsAbbrevK: 'K',
    creditsAbbrevM: 'M',
    deposit: 'Depósito de {{amount}} moedas',
    historyTitle: 'Histórico de XP',
    howItWorksTitle: 'Como funciona',
    howItWorksFeature1: '{{maxLevel}} níveis para subir',
    howItWorksFeature2: 'Cada nível seguinte exige mais XP',
    howItWorksFeature3: 'Complete missões e fique ativo para ganhar XP',
    howItWorksFeature4: 'Ganhe recompensas exclusivas e participe das atividades',
    keyLevels: 'Níveis-chave',
    xpSourcesTitle: 'Como ganhar XP',
    tabActivity: 'Atividade',
    tabGameplay: 'Jogos',
    tabSocial: 'Amigos',
    rewardsDailyLogin: 'Login diário',
    rewardsWeeklyStreak: 'Sequência de 7 dias',
    rewardsContract: 'Criação de contrato',
    rewardsUpgradeSuccess: 'Upgrade bem-sucedido',
    rewardsUpgradeFail: 'Upgrade falhou',
    rewardsDrawParticipation: 'Participação em sorteio',
    rewardsDrawWin: 'Recompensa por atividade',
    rewardsReferralInvite: 'Convite de amigo',
    rewardsReferralDeposit: 'Depósito de indicado',
    rewardsCaseBattleWin: 'Vitória em batalha de caixas',
    rewardsCaseBattleLose: 'Derrota em batalha de caixas',
    rewardsRouletteWin: 'Vitória na roleta russa',
    rewardsRouletteLose: 'Derrota na roleta russa',
    caseGroupsCheap: 'Caixas baratas',
    caseGroupsMedium: 'Caixas médias',
    caseGroupsExpensive: 'Caixas caras',
    faqTitle: 'Perguntas frequentes',
    faqQ1: 'O que dá mais XP?',
    faqA1: 'O que mais dá XP: abrir caixas caras, depósitos, vitórias em sorteios e convidar indicados ativos.',
    faqQ2: 'Posso perder meu nível?',
    faqA2: 'Não, seu nível nunca cai. XP pode ser descontado por inatividade, mas o nível alcançado fica com você.',
    faqQ3: 'Como subir de nível mais rápido?',
    faqA3: 'Combine: login diário, abertura de caixas, depósitos, convite de amigos e participação em sorteios.',
    faqQ4: 'No que o nível influencia?',
    faqA4: 'Os níveis dão vários bônus: recompensas únicas por alcançar novos níveis, privilégios permanentes e acesso a atividades exclusivas.',
  },
  tr: {
    level: 'Seviye',
    toNextLevel: 'Sonraki seviyeye',
    creditsAbbrevK: 'K',
    creditsAbbrevM: 'M',
    deposit: '{{amount}} coin yatırma',
    historyTitle: 'XP geçmişi',
    howItWorksTitle: 'Nasıl çalışır',
    howItWorksFeature1: 'Açılacak {{maxLevel}} seviye',
    howItWorksFeature2: 'Her sonraki seviye daha fazla XP ister',
    howItWorksFeature3: 'XP kazanmak için görevleri tamamla ve aktif ol',
    howItWorksFeature4: 'Özel ödüller kazan ve etkinliklere katıl',
    keyLevels: 'Önemli seviyeler',
    xpSourcesTitle: 'XP nasıl kazanılır',
    tabActivity: 'Etkinlik',
    tabGameplay: 'Oyunlar',
    tabSocial: 'Arkadaşlar',
    rewardsDailyLogin: 'Günlük giriş',
    rewardsWeeklyStreak: '7 günlük seri',
    rewardsContract: 'Kontrat oluşturma',
    rewardsUpgradeSuccess: 'Başarılı upgrade',
    rewardsUpgradeFail: 'Başarısız upgrade',
    rewardsDrawParticipation: 'Çekilişe katılım',
    rewardsDrawWin: 'Etkinlik ödülü',
    rewardsReferralInvite: 'Arkadaş daveti',
    rewardsReferralDeposit: 'Davet edilenin yatırması',
    rewardsCaseBattleWin: 'Kasa savaşı zaferi',
    rewardsCaseBattleLose: 'Kasa savaşı yenilgisi',
    rewardsRouletteWin: 'Rus ruletinde zafer',
    rewardsRouletteLose: 'Rus ruletinde yenilgi',
    caseGroupsCheap: 'Ucuz kasalar',
    caseGroupsMedium: 'Orta kasalar',
    caseGroupsExpensive: 'Pahalı kasalar',
    faqTitle: 'Sık sorulan sorular',
    faqQ1: 'En çok XP ne kazandırır?',
    faqA1: 'En çok XP şunlardan gelir: pahalı kasa açmak, bakiye yüklemek, çekiliş kazanmak ve aktif arkadaşlar davet etmek.',
    faqQ2: 'Seviyemi kaybedebilir miyim?',
    faqA2: 'Hayır, seviyen asla düşmez. Hareketsizlik yüzünden XP kesilebilir ama ulaştığın seviye sende kalır.',
    faqQ3: 'Daha hızlı nasıl seviye atlarım?',
    faqA3: 'Hepsini birleştir: günlük giriş, kasa açma, bakiye yükleme, arkadaş davet etme ve çekilişlere katılma.',
    faqQ4: 'Seviye neyi etkiler?',
    faqA4: 'Seviyeler çeşitli bonuslar verir: yeni seviyeye ulaşınca tek seferlik ödüller, kalıcı ayrıcalıklar ve özel etkinliklere erişim.',
  },
});
